<div class="modal-header">
  @if (this.type === 'group') {
    <h5
      class="modal-title"
      i18n="@@new-group"
    >Neue Projektgruppe</h5>
  }
  @if (this.type === 'user') {
    <h5
      class="modal-title"
      i18n="@@new-user"
    >Neuer Projektnutzer</h5>
  }
  <p-button
    type="button"
    severity="secondary"
    [text]="true"
    [rounded]="true"
    icon="ri-close-fill ri-xl"
    (onClick)="this.cancel()"
  ></p-button>
</div>
<div class="modal-body">
  <div class="card-body">
    <div class="row mb-1 align-items-center">
      <div class="col-3">
        <span i18n="@@name-label">Name:</span>
      </div>
      <div class="col">
        <input
          pInputText
          pSize="small"
          fluid
          type="text"
          [(ngModel)]="this.name"
          >
      </div>
    </div>
    @if (this.type === 'user') {
      <div
        class="row align-items-center"
        >
        <div class="col-3">
          <span i18n="@@mail-optional">E-Mail (optional):</span>
        </div>
        <div class="col">
          <input
            pInputText
            pSize="small"
            fluid
            type="text"
            [(ngModel)]="this.email"
            >
        </div>
      </div>
    }
  </div>
</div>

<div class="modal-footer">
  <p-button
    type="button"
    severity="primary"
    label="Hinzufügen"
    i18n-label="@@add"
    (onClick)="this.add()"
    [disabled]="this.checkInput()"
  ></p-button>
</div>